import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import BlogPage from './pages/BlogPage';
import BorrowingDeviceOnlineV2 from './pages/BorrowingDeviceOnlineV2';
import BorrowingLocal from './pages/BorrowingLocal';
import Canbinet from './pages/Cabinet';
import CategoryPage from './pages/Category';
import Cell from './pages/Cell';
import ConfigEmailSMTP from './pages/ConfigEmailSMTP';
import DashboardAppPage from './pages/DashboardAppPage';
import Department from './pages/Department';
import Drawer from './pages/Drawer';
import ExportStaticstical from './pages/ExportStaticstical';
import GetDeviceLocal from './pages/GetDeviceLocal';
import GetDeviceOnlineV2 from './pages/GetDeviceOnlineV2';
import GiveDevice from './pages/GiveDevice';
import GroupDevice from './pages/GroupDevice';
import GroupDeviceAction from './pages/GroupDeviceAction';
import ImportWarehouse from './pages/ImportWarehouse';
import ListConfigDevice from './pages/ListConfigDevice';
import ListScreenPermissionPage from './pages/ListScreenPermissionPage';
import ListTakeDevice from './pages/list-take-device';
import LoginPage from './pages/LoginPage';
import ManagerAdmin from './pages/ManagerAdmin';
import Page404 from './pages/Page404';
import PermissionsManagement from './pages/PermissionsManagement';
import PrintsQRCode from './pages/PrintsQRCode';
import ProductsPage from './pages/ProductsPage';
import PropertyDefault from './pages/PropertyDefault';
import ReportWareHouse from './pages/ReportWareHouse';
import Statistical from './pages/Statistical';
import Supplier from './pages/Supplier';
import Users from './pages/User';
import UserPage from './pages/UserPage';
import ExportReport from './pages/report';
import ListBorrowingDevice from './pages/list-borrow-device';
import ApproveRequest from './pages/approveRequest';
import RequestDevices from './pages/RequestDevices';
import ReviewReturnDevice from './pages/reviewReturnDevice';

// ----------------------------------------------------------------------

export default function Router() {
    const routes = useRoutes([
        {
            path: '/home',
            element: <DashboardLayout />,
            children: [
                { element: <Navigate to="/home/app" />, index: true },
                { path: 'app', element: <DashboardAppPage /> },
                { path: 'user', element: <UserPage /> },

                { path: 'group-device/:idPermission/devices/:idGroup', element: <ProductsPage /> },
                { path: 'group-device/:idPermission', element: <GroupDevice /> },

                { path: 'statictical-check/:idPermission', element: <PropertyDefault /> },
                { path: 'statictical-check/:idPermission/export-staticstical', element: <ExportStaticstical /> },

                { path: 'config-email/:idPermission', element: <ConfigEmailSMTP /> },
                { path: 'manager-admin/:idPermission', element: <ManagerAdmin /> },

                { path: 'manager-cabinet/:idPermission', element: <Canbinet /> },
                { path: 'manager-cabinet/:idPermission/config-devices', element: <ListConfigDevice /> },
                { path: 'decentralization/:idPermission', element: <PermissionsManagement /> },
                { path: 'manager-screens/:idPermission', element: <ListScreenPermissionPage /> },
                { path: 'supplier/:idPermission', element: <Supplier /> },

                { path: 'statistical/:idPermission', element: <Statistical /> },

                { path: 'give-back-device/:idPermission', element: <GiveDevice /> },
                { path: 'list-get-device/:idPermission', element: <ListTakeDevice /> },
                { path: 'list-give-device/:idPermission', element: <ListBorrowingDevice /> },
                { path: 'export-report/:idPermission', element: <ExportReport /> },

                { path: 'export-report/:idPermission/export-ware-house', element: <ReportWareHouse /> },

                { path: 'category/:idPermission', element: <CategoryPage /> },
                // { path: 'manager-devices/:idPermission', element: <ImportWarehouse /> },

                { path: 'group/borrow-local/:idPermission', element: <GroupDeviceAction /> },
                { path: 'group/take-local/:idPermission', element: <GroupDeviceAction /> },
                { path: 'group/take-online/:idPermission', element: <GroupDeviceAction /> },
                { path: 'group/:action/:idPermission', element: <GroupDeviceAction /> },

                // action => local/online
                { path: 'group/borrow-local/:idPermission/borrow-local/:idGroup', element: <BorrowingLocal /> },
                { path: 'group/take-local/:idPermission/take-local/:idGroup/', element: <GetDeviceLocal /> },
                { path: 'group/:action/:idPermission/take-online/:idGroup', element: <GetDeviceOnlineV2 /> },
                { path: 'group/:action/:idPermission/manager-devices/:idGroup', element: <ImportWarehouse /> },
                { path: 'group/:action/:idPermission/take-online/:idGroup', element: <GetDeviceOnlineV2 /> },
                {
                    path: 'group/borrow-online/:idPermission/borrow-online/:idGroup',
                    element: <BorrowingDeviceOnlineV2 />,
                },
                // end

                { path: 'staffs/:idPermission', element: <Users /> },
                { path: 'manager-department/:idPermission', element: <Department /> },
                { path: 'manager-cabinet/:idPermission/drawer/:idCabinet/cell/:idDrawer', element: <Cell /> },
                { path: 'manager-cabinet/:idPermission/drawer/:idCabinet', element: <Drawer /> },
                { path: 'blog', element: <BlogPage /> },

                //Print QR devices
                { path: 'print-qr-devices/:idPermission', element: <PrintsQRCode /> },
                { path: 'approve_request/:idPermission', element: <ApproveRequest /> },

                { path: 'request_devices/:idPermission', element: <RequestDevices /> },
                { path: 'review_return_device/:idPermission', element: <ReviewReturnDevice /> },
            ],
        },
        {
            path: 'login',
            element: <LoginPage />,
        },
        {
            element: <SimpleLayout />,
            children: [
                { element: <Navigate to="/home/app" />, index: true },
                { path: '404', element: <Page404 /> },
                { path: '*', element: <Navigate to="/404" /> },
            ],
        },
        {
            path: '*',
            element: <Navigate to="/404" replace />,
        },
    ]);

    return routes;
}
